import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

export default function useEmailVerification(token, verifyTokenFirst = false) {
  const request = useRef(null);
  const [result, setResult] = useState({ status: 'loading', message: '' });

  useEffect(() => {
    let active = true;
    if (!token) {
      setResult({ status: 'error', message: 'The verification link is missing its token.' });
      return;
    }
    // Reuse the mutation during Strict Mode's setup/cleanup replay.
    if (request.current?.token !== token || request.current?.verifyTokenFirst !== verifyTokenFirst) {
      const verify = async () => {
        const data = { token };
        if (verifyTokenFirst) await axios.post(`${process.env.REACT_APP_API}users/token-verify`, data);
        return axios.post(`${process.env.REACT_APP_API}users/email-verify`, data);
      };
      request.current = { token, verifyTokenFirst, promise: verify() };
    }
    setResult({ status: 'loading', message: '' });
    request.current.promise.then(response => {
      if (active) setResult({ status: 'success', message: response?.data?.message || 'Your account is verified.' });
    }).catch(error => {
      if (!active) return;
      const message = error?.response?.data?.message;
      setResult({ status: 'error', message: typeof message === 'string' && message ? message : 'Unable to verify your account. Please try again.' });
    });
    return () => { active = false; };
  }, [token, verifyTokenFirst]);

  return result;
}
